import logoWord from "../../assets/storefront/logo-word.svg";
import logoMono from "../../assets/storefront/logo-mono.svg";
import logoMonoCream from "../../assets/storefront/logo-mono-cream.svg";
import ss26Manifest from "../../assets/storefront/ss26/manifest.json";

/**
 * SS26 photography, as responsive descriptors rather than single files.
 *
 * The shoot is imported as a width ladder (360/720, plus 1080 for the pictures
 * that go full-bleed) built by scripts/optimize-images.sh. Every entry carries
 * its intrinsic dimensions so <img> can reserve its box before the bytes land.
 *
 * require.context keeps this to one line instead of 112 import statements. It
 * is a webpack API — if this app ever moves to Vite, swap it for
 * `import.meta.glob`.
 */
const ss26Context = require.context("../../assets/storefront/ss26", false, /-\d+\.jpg$/);

const urlByFile = ss26Context.keys().reduce((acc, key) => {
  acc[key.replace("./", "").replace(".jpg", "")] = ss26Context(key);
  return acc;
}, {});

const LADDER = [360, 720, 1080];

function buildDescriptor({ stem, width, height }) {
  const available = LADDER.filter((w) => urlByFile[`${stem}-${w}`]);
  if (!available.length) return null;
  // The widest tier is the src so a browser without srcSet support still gets a
  // usable picture; anything modern picks from srcSet and ignores it.
  const fallbackWidth = available[available.length - 1];
  return {
    src: urlByFile[`${stem}-${fallbackWidth}`],
    srcSet: available.map((w) => `${urlByFile[`${stem}-${w}`]} ${w}w`).join(", "),
    width,
    height,
  };
}

const descriptorByStem = ss26Manifest.reduce((acc, entry) => {
  const descriptor = buildDescriptor(entry);
  if (descriptor) acc[entry.stem] = descriptor;
  return acc;
}, {});

/** Every descriptor, in manifest order — the pool the fallbacks draw from. */
export const ss26Images = ss26Manifest
  .map((entry) => descriptorByStem[entry.stem])
  .filter(Boolean);

function pick(stem) {
  return descriptorByStem[String(stem)] || null;
}

const listingHeroVisuals = [
  "20", "22", "24", "26", "28", "29", "30", "72", "79", "98", "113",
].map(pick).filter(Boolean);

export function ss26Image(index = 0) {
  return ss26Images[Math.abs(index) % ss26Images.length];
}

/**
 * Fotosuz məhsulun üzü. Əvvəl bura yığma DEMO fotoqrafiya düşürdü — ERP-nin
 * ~600 məhsulu publish olunanda vitrin başqa paltarların şəkilləri ilə doldu.
 * Yad malın fotosu yanlış məlumatdır; neytral brend lövhəsi isə sadəcə
 * «şəkil hələ yoxdur» deyir. Şəkil bağlanan kimi bu, öz-özünə yox olur.
 */
const PLACEHOLDER_SVG = encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 960">' +
  '<rect width="720" height="960" fill="#F3F0EB"/>' +
  '<rect x="24" y="24" width="672" height="912" fill="none" stroke="#4A3B2E" stroke-opacity="0.14" stroke-width="1"/>' +
  '<text x="360" y="470" text-anchor="middle" font-family="Georgia, \'Times New Roman\', serif" font-size="118" fill="#4A3B2E" fill-opacity="0.28">A</text>' +
  '<text x="360" y="540" text-anchor="middle" font-family="Georgia, \'Times New Roman\', serif" font-size="21" letter-spacing="7" fill="#4A3B2E" fill-opacity="0.34">ATELIER DI FALCO</text>' +
  "</svg>",
);
export const productPlaceholderSrc = `data:image/svg+xml;charset=utf-8,${PLACEHOLDER_SVG}`;
const productPlaceholder = { src: productPlaceholderSrc };

export function productImage() {
  return productPlaceholder;
}

export function listingHeroImage(index = 0) {
  return listingHeroVisuals[Math.abs(index) % listingHeroVisuals.length];
}

export function localProductImages(index = 0) {
  return [productImage(index), productImage(index + 1), productImage(index + 2), productImage(index + 3)];
}

export const adfAssets = {
  logoWord,
  logoMono,
  logoMonoCream,
  hero: pick("75"),
  jacket1: pick("20"),
  jacket2: pick("28"),
  shirt1: pick("23"),
  shirt2: pick("26"),
  cardigan: pick("30"),
  trousers: pick("29"),
  fabrics: pick("21"),
  showroom: pick("27"),
  accessories: pick("31"),
  collections: pick("76"),
  contact: pick("112"),
  brand: pick("73"),
  vision: pick("113"),
};

export const categoryTiles = [
  { titleKey: "home.category.suits", title: "Kostyumlar", to: "/category/suits", image: pick("20") },
  { titleKey: "home.category.shirts", title: "Köynəklər", to: "/category/shirts", image: pick("23") },
  { titleKey: "home.category.shoes", title: "Ayaqqabılar", to: "/category/shoes", image: pick("29") },
  { titleKey: "home.category.accessories", title: "Aksesuarlar", to: "/category/accessories", image: pick("31") },
];
